<template>
    <div id="owner" class="col-xs-12">
        <h4>Sobre o Anunciante</h4>
        <div class="border m-b-30"></div>
        <div class="row">
            <div class="col-sm-2 col-sm-2 text-center">
                <img
                    :src="user.photo_url"
                    class="img-circle img-thumbnail"
                    alt="profile-image"
                    loading="lazy"
                    fetchpriority="high"
                />
                <div>
                    <h4>{{ user.full_name }}</h4>
                </div>
                <div class="row m-t-10">
                    <a :href="`/perfil-host/${user.id}`">Ver perfil e anúncios</a>
                </div>
            </div>

            <div class="col-sm-5 col-sm-5">
                <div class="row">
                    <ul id="owner_list" class="list-unstyled col-xs-12">
                        <li v-if="user.verifications.account" class="col-sm-12 m-b-15">
                            <span class="verified m-b-5">
                                <img src="/images/verified.png" class="m-r-10" alt="" />

                                Anunciante verificado
                            </span>
                        </li>

                        <li v-if="user.verifications.mobile" class="col-sm-12 m-b-15">
                            <span class="verified m-b-5">
                                <img src="/images/phone.png" class="m-r-10" alt="" />

                                Telefone confirmado
                            </span>
                        </li>

                        <li v-if="user.verifications.facebook" class="col-sm-12 m-b-15">
                            <span class="verified m-b-5">
                                <img src="/images/fb.png" class="m-r-10" alt="" />

                                Facebook confirmado
                            </span>
                        </li>

                        <li class="col-sm-12 m-b-15">
                            <span class="verified m-b-5">
                                <img src="/images/calendar.png" class="m-r-10" alt="" />
                                Cadastrado {{ user.registered_since }}
                            </span>
                        </li>

                        <li class="col-sm-12 m-b-15">
                            <span class="verified m-b-5">
                                <img src="/images/clock.png" class="m-r-10" alt="" />
                                Ativo pela última vez {{ user.last_activity }}
                            </span>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="col-sm-5 col-md-5">
                <div
                class="d-flex align-center justify-between"
                style="
                    background-color: #f7f7f7;
                    height: 4rem;
                    border-radius: 1rem;
                    padding: 0 2rem;
                "
                >
                    <span
                        class="rating bg-danger"
                        :class="
                        rulerVisibility(user.ru < 0.2 && Boolean(is_score_ruler_visible))
                        "
                    ></span>
                    <span
                        class="rating bg-yellow"
                        :class="
                            rulerVisibility(
                                user.ru < 0.4 &&
                                user.ru >= 0.2 &&
                                Boolean(is_score_ruler_visible)
                            )
                        "
                    ></span>
                    <span
                        class="rating bg-gray"
                        :class="
                            rulerVisibility(
                                (user.ru < 0.6 && user.ru >= 0.4) ||
                                Boolean(is_score_ruler_visible) === false
                            )
                        "
                    ></span>
                    <span
                        class="rating bg-green"
                        :class="
                            rulerVisibility(
                                user.ru < 0.8 &&
                                user.ru >= 0.6 &&
                                Boolean(is_score_ruler_visible)
                            )
                        "
                    ></span>
                    <span
                        class="rating bg-blue"
                        :class="
                            rulerVisibility(
                                user.ru <= 1 &&
                                user.ru >= 0.8 &&
                                Boolean(is_score_ruler_visible)
                            )
                        "
                    ></span>
                </div>
                <div class="d-flex m-t-10">
                    <div class="d-flex flex-column" style="width: 50%">
                        <span class="stats">Taxa de Resposta:</span>
                        <span class="stats-value">{{ user.response_rate }}</span>
                    </div>
                    <hr
                        style="
                            width: 45px;
                            border: 1px solid #eeeeee;
                            transform: rotate(90deg);
                        "
                    />
                    <div class="d-flex flex-column" style="width: 50%">
                        <span class="stats">Nível: </span>
                        <span class="stats-value">{{ userLevel() }}</span>
                    </div>
                </div>
                <div class="d-flex align-center justify-between m-t-10">
                    <vue-star-rating
                        v-model="visibleScore"
                        name="rating"
                        :increment="0.5"
                        border-color="#cbb956"
                        :rounded-corners="true"
                        :star-size="30"
                        :read-only="true"
                        :show-rating="false"
                    ></vue-star-rating>
                    <span class="score">{{ visibleScore }}/5</span>
                </div>
                <div class="d-flex align-center justify-between m-t-10">
                    <rating-number
                        :fk_property="fk_property"
                        :ratings_received="ratings_received"
                        :user="user"
                    >
                    </rating-number>
                    <span>
                        <a href="/roommate/alugueis">Avaliar {{ user.full_name }}</a>
                    </span>
                </div>
                <div v-if="ratings_received == 0" class="d-flex align-center justify-between m-t-15 card-box">
                    <p class="m-0">Este(a) anfitriã(o) ainda não teve alugueis registrados ou avaliações de inquilinos no WebQuarto.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ratingNumber from "../../rentals/rating-number.vue";
import VueStarRating from "../../../../../../legacy/node_modules/vue-star-rating";

export default {
    props: {
        fk_property: {
            type: Number,
            required: true,
        },
        is_score_ruler_visible: {
            type: Number,
            required: true,
        },
        ratings_received: {
            type: Number,
            required: true,
        },
        ratings_score: {
            type: Number,
            required: true,
        },
        user: {
            type: Object,
            required: true,
        },
    },
    components: {
        ratingNumber,
        VueStarRating,
    },
    computed: {
        visibleScore() {
            if (this.ratings_received > 0)
                return this.ratings_score;
            else
                return 0;
        }
    },
    methods: {
        rulerVisibility(condition) {
            if (condition === false) {
                return "opacity-25";
            }
        },
        userLevel() {
            if (
                (this.user.ru >= 0.4 && this.user.ru < 0.6) ||
                this.is_score_ruler_visible === 0
            )
                return "Neutro";
            else if (this.user.ru < 0.4) return "Ruim";
            else if (this.user.ru >= 0.6 && this.user.ru < 0.8) return "Bom";
            else if (this.user.ru >= 0.8) return "Profissional";
        },
    },
};
</script>

<style lang="scss" scoped>
.d-flex {
    display: flex;
}

.flex-column {
    flex-direction: column;
}

.align-center {
    align-items: center;
}

.justify-between {
    justify-content: space-between;
}

.bg-gray {
    background-color: #808080;
}

.bg-yellow {
    background-color: #f9c851;
}

.bg-green {
    background-color: #4bd396;
}

.bg-blue {
    background-color: #0077ff;
}

.opacity-25 {
    opacity: 0.15;
}

.rating {
    height: 1rem;
    width: 7rem;
    border-radius: 10px;
}

.stats {
    font-size: 16px;
    color: #7a7a7a;
    font-weight: 700;
}

.stats-value {
    font-size: 24px;
    color: #0077ff;
    font-weight: 700;
}

.score {
    font-size: 32px;
    color: #7a7a7a;
    font-weight: 700;
}

.score-action {
    font-size: 16px;
    color: #3197d1;
    font-weight: 500;
}
</style>
